import AffirmCTA from '@components/AffirmCTA';
import React from 'react';
import { ProductContext } from '@context/ProductProvider';
import createCurrencyString from '@repo/ui/src/functions/currency-functions';
import CallToActionButton from '../CallToActionButton';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { classNames } from '@repo/ui/src/utils/classNames';
import HeaderPaddingWrapper from '@repo/ui/src/components/HeaderPaddingWrapper';

interface Props {
  name?: string;
  size?: string;
  hideCTA?: boolean;
}

const ProductNav = ({ name, size, hideCTA = false }: Props) => {
  const { totalPrice, originalPrice, addToCart, isLoadingAddToCart, mainProduct } =
    React.useContext(ProductContext);
  const { currency, locale } = useCurrentUrl();

  return (
    <div
      className={classNames(
        'tw-sticky tw-top-[var(--navTop)] tw-inset-x-0 tw-bg-neutral-600 tw-items-center tw-z-[200] tw-py-2 tw-overflow-x-hidden',
        hideCTA && 'tw-py-4',
      )}
      role="region"
      aria-label="promo"
    >
      <HeaderPaddingWrapper className="sm:tw-grid sm:tw-grid-cols-[minmax(0,1fr)_auto]">
        <h2 className="tra-text-web-heading-7 tw-text-warm-100 tw-hidden sm:tw-block">
          {name} {size && <span className="tw-text-brand-300">{size}</span>}
        </h2>
        <div className="tw-grid tw-grid-cols-[minmax(0,1fr)_auto] tw-items-center">
          <div className="tw-flex tw-flex-row tw-text-warm-100 tw-mr-5 tw-items-center tw-gap-x-1 sm:tw-gap-x-2.5">
            {!!Number(totalPrice) && mainProduct?.ctaButtonType !== 'noCTA' && (
              <h6 className="tra-text-web-heading-7 !tw-text-2xl" data-testid="nav-price">
                {createCurrencyString(locale, currency, Number(totalPrice))}
              </h6>
            )}
            {totalPrice !== originalPrice && (
              <h6 className="tra-text-web-heading-7 tw-ml-[14px] tw-line-through">
                {createCurrencyString(locale, currency, Number(originalPrice))}
              </h6>
            )}
            {!!totalPrice && locale === 'en-US' && (
              <AffirmCTA
                amount={totalPrice}
                className="tw-hidden md:tw-block tw-pl-2 affirm-dark"
              />
            )}
          </div>
          {!hideCTA && mainProduct && (
            <CallToActionButton
              buttonProps={{
                size: 'small',
                disabled: isLoadingAddToCart,
              }}
              buttonProcessing={isLoadingAddToCart}
              processingText=""
              onClickAddToCart={() => addToCart(1)}
              customProductPrice={Number(totalPrice)}
              product={mainProduct}
            />
          )}
        </div>
      </HeaderPaddingWrapper>
    </div>
  );
};

export default ProductNav;
